import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import { type CalculationResult, formatPaybackDays, formatRub, formatSignedRub } from '../../lib';

import styles from '@/components/TariffCalculatorNew/TariffCalculator.module.scss';

interface MetricProps {
	label: string;
	value: string;
	benefit?: boolean;
}

function Metric({ label, value, benefit = false }: MetricProps) {
	return (
		<div className={`${styles.metric}${benefit ? ` ${styles.benefit}` : ''}`}>
			<span>{label}</span>
			<strong>{value}</strong>
		</div>
	);
}

interface ScenarioCardsProps {
	result: CalculationResult;
}

export function ScenarioCards({ result }: ScenarioCardsProps) {
	const { t } = useTranslation(TranslationNamespace.Calculator);
	return (
		<div className={styles.scenarioGrid}>
			<article className={`${styles.scenario} ${styles.conservative}`}>
				<h3>{t('results.conservative-title')}</h3>
				<p>{t('results.conservative-description')}</p>
				<Metric label={t('results.after-month')} value={formatRub(result.consAfterYear / 12)} />
				<Metric label={t('results.after-year')} value={formatRub(result.consAfterYear)} />
				<Metric
					label={t('results.benefit-month')}
					value={formatSignedRub(result.consBenefitYear / 12)}
					benefit
				/>
				<Metric
					label={t('results.benefit-year')}
					value={formatSignedRub(result.consBenefitYear)}
					benefit
				/>
				<Metric label={t('results.payback')} value={formatPaybackDays(result.consPayback)} />
			</article>

			<article className={`${styles.scenario} ${styles.positive}`}>
				<h3>{t('results.positive-title')}</h3>
				<p>{t('results.positive-description')}</p>
				<Metric label={t('results.after-month')} value={formatRub(result.posAfterYear / 12)} />
				<Metric label={t('results.after-year')} value={formatRub(result.posAfterYear)} />
				<Metric
					label={t('results.benefit-month')}
					value={formatSignedRub(result.posBenefitYear / 12)}
					benefit
				/>
				<Metric
					label={t('results.benefit-year')}
					value={formatSignedRub(result.posBenefitYear)}
					benefit
				/>
				<Metric label={t('results.payback')} value={formatPaybackDays(result.posPayback)} />
			</article>
		</div>
	);
}
